import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, Download, Clock } from "lucide-react";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString([], { dateStyle: "medium", timeStyle: "short" }) : null);

export const BuyerDownloads = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/sales").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);

  if (!rows) return <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 animate-spin text-[#e2ff31]" /></div>;
  const pending = rows.filter((r) => !r.first_downloaded_at).length;
  const carded = rows.filter((r) => r.card_downloads + r.card_shares > 0).length;
  const shared = rows.filter((r) => r.card_shares > 0).length;

  return (
    <div data-testid="buyer-downloads" className="bg-[#121212] border border-[#2a2a2a] rounded-2xl p-6">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
        <div>
          <h2 className="font-heading text-lg font-semibold">Buyer downloads</h2>
          <p className="text-sm text-[#9ca3af]">When each buyer first grabbed their beat.</p>
        </div>
        <div className="flex flex-wrap gap-2">
        <span data-testid="card-share-summary" className="text-xs font-mono rounded-full px-3 py-1 border border-[#e2ff31]/40 text-[#e2ff31]">
          {carded} of {rows.length} saved their card · {shared} shared
        </span>
        <span data-testid="buyer-downloads-pending" className={`text-xs font-mono rounded-full px-3 py-1 border ${pending ? "text-[#f59e0b] border-[#f59e0b]/40" : "text-[#22c55e] border-[#22c55e]/40"}`}>
          {pending ? `${pending} not downloaded yet` : "All delivered"}
        </span>
        </div>
      </div>
      {rows.length === 0 ? (
        <p data-testid="buyer-downloads-empty" className="text-sm text-[#6b7280] py-8 text-center">No sales yet.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs uppercase tracking-wider text-[#6b7280] border-b border-[#2a2a2a]">
                <th className="py-2 pr-4 font-medium">Beat</th><th className="py-2 pr-4 font-medium">Buyer</th>
                <th className="py-2 pr-4 font-medium">Purchased</th><th className="py-2 pr-4 font-medium">First download</th>
                <th className="py-2 pr-4 font-medium text-right">Downloads</th>
                <th className="py-2 font-medium text-right">Share card</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} data-testid={`sale-row-${r.id}`} className="border-b border-[#1e1e1e] last:border-0">
                  <td className="py-3 pr-4 font-medium">{r.track_title}<span className="block text-xs font-mono text-[#e2ff31]">${r.amount.toFixed(2)}</span></td>
                  <td className="py-3 pr-4">{r.buyer_name || "—"}<span className="block text-xs text-[#6b7280]">{r.buyer_email}</span></td>
                  <td className="py-3 pr-4 text-[#9ca3af] whitespace-nowrap">{fmt(r.purchased_at) || "—"}</td>
                  <td data-testid={`sale-first-download-${r.id}`} className="py-3 pr-4 whitespace-nowrap">
                    {r.first_downloaded_at
                      ? <span className="inline-flex items-center gap-1.5 text-[#22c55e]"><Download className="w-3.5 h-3.5" />{fmt(r.first_downloaded_at)}</span>
                      : <span className="inline-flex items-center gap-1.5 text-[#f59e0b]"><Clock className="w-3.5 h-3.5" />Not yet</span>}
                  </td>
                  <td data-testid={`sale-download-count-${r.id}`} className="py-3 pr-4 text-right font-mono">{r.download_count}</td>
                  <td data-testid={`sale-card-stats-${r.id}`} className="py-3 text-right font-mono text-xs whitespace-nowrap">
                    {r.card_downloads + r.card_shares === 0 ? <span className="text-[#6b7280]">—</span>
                      : <span className="text-[#e2ff31]">{r.card_downloads} saved · {r.card_shares} shared</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
